(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mm-new-arrivals-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[id^="MmSlider-"]').forEach(function (root) {
      if (root.dataset.mmInit) return;
      root.dataset.mmInit = "true";

      var slides = Array.prototype.slice.call(root.querySelectorAll('.mm-slide'));
      var dots = Array.prototype.slice.call(root.querySelectorAll('.mm-slider__dot'));
      var prevBtn = root.querySelector('.mm-slider__arrow--prev');
      var nextBtn = root.querySelector('.mm-slider__arrow--next');

      var current = 0;
      var total = slides.length;
      if (total < 2) return;
      var AUTOPLAY_MS = 5500;
      var timer = null;

      function goTo(index) {
        index = (index + total) % total;
        slides[current].classList.remove('is-active');
        if (dots[current]) { dots[current].classList.remove('is-active'); dots[current].setAttribute('aria-selected', 'false'); }
        current = index;
        slides[current].classList.add('is-active');
        if (dots[current]) { dots[current].classList.add('is-active'); dots[current].setAttribute('aria-selected', 'true'); }
      }
      function next() { goTo(current + 1); }
      function prev() { goTo(current - 1); }
      function startAutoplay() { stopAutoplay(); timer = setInterval(next, AUTOPLAY_MS); }
      function stopAutoplay() { if (timer) clearInterval(timer); timer = null; }

      if (nextBtn) nextBtn.addEventListener('click', function () { next(); startAutoplay(); });
      if (prevBtn) prevBtn.addEventListener('click', function () { prev(); startAutoplay(); });
      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () { goTo(i); startAutoplay(); });
      });

      root.addEventListener('mouseenter', stopAutoplay);
      root.addEventListener('mouseleave', startAutoplay);
      root.addEventListener('focusin', stopAutoplay);
      root.addEventListener('focusout', startAutoplay);

      root.setAttribute('tabindex', '0');
      root.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { next(); startAutoplay(); }
        if (e.key === 'ArrowLeft') { prev(); startAutoplay(); }
      });

      var touchStartX = 0;
      root.addEventListener('touchstart', function (e) { touchStartX = e.changedTouches[0].screenX; }, { passive: true });
      root.addEventListener('touchend', function (e) {
        var touchEndX = e.changedTouches[0].screenX;
        var delta = touchEndX - touchStartX;
        if (Math.abs(delta) > 40) { (delta < 0 ? next : prev)(); startAutoplay(); }
      }, { passive: true });

      startAutoplay();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
